import personal from "./shared/personal";

export default {
	title: "PersonalInfo",
	description: "schemas_personal_info_title",
	type: "object",
	properties: personal
};
